import type { FC } from 'react';
import React from 'react';

import { useTranslation } from 'react-i18next';

import { Label } from '@pflegenavi/web-components';
import { Stack, Typography } from '@mui/material';

export const InactiveDirectDebitInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Label sx={{ mb: 2, p: 1.8 }} variant="filled" color="info">
        {t('mobile.family-member.settlement-label')}
      </Label>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
          {t('mobile.family-member.final-settlement-completed')}
        </Typography>
      </Stack>
      <Typography variant="subtitle1">
        {t('mobile.family-member.contact-nursing-home')}
      </Typography>
    </>
  );
};
